import { nanoid } from 'nanoid'

export function genId() {
  return nanoid(8)
}
